import type { Tab } from '@/components/loop-dashboard/types/tabs';
import { itemSearched, OriginPage } from '../Avo';
import { getOriginView } from './getOriginView';

// Track when the next navigation is from a search selection
let isNextNavigationFromSearch = false;

export const setNextNavigationFromSearch = () => {
  isNextNavigationFromSearch = true;
};

export const consumeNextNavigationFromSearch = (): boolean => {
  const value = isNextNavigationFromSearch;
  isNextNavigationFromSearch = false;
  return value;
};

export const trackItemSearched = (currentTab: Tab) => {
  itemSearched({
    originPage: OriginPage.INSIGHTS_DASHBOARD,
    originView: getOriginView(currentTab),
  });
};
